// extracted by mini-css-extract-plugin
module.exports = {"resultItem":"ValueCard_resultItem__3xXi4","resultItemTitle":"ValueCard_resultItemTitle__G-06g","amountNumber":"ValueCard_amountNumber__3Ulnl","loader":"ValueCard_loader__2wVpS"};